import { render, staticRenderFns } from "./AreaCameras.vue?vue&type=template&id=c1081092&scoped=true"
import script from "./AreaCameras.vue?vue&type=script&lang=ts"
export * from "./AreaCameras.vue?vue&type=script&lang=ts"
import style0 from "./AreaCameras.vue?vue&type=style&index=0&id=c1081092&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1081092",
  null
  
)

export default component.exports